export default {
  // ========== Header ==========
  pia: "PIA",
  suitcase: "Instructional",
  didactic: "Kit",
  subjectImplementationProgram: "Subject Implementation Program",

  // ========== Section 1: General Background ==========
  generalBackground: "General Background",
  careerName: "Career Name(s)",
  studyPlans: "Study Plans",
  totalHours: "Total Hours",
  programmingWeeks: "No. of Programming Weeks",
  inPersonDirectTeaching: "In-Person Direct Teaching",
  nonInPersonDirectTeaching: "Non In-Person Direct Teaching",
  pedagogicalHours: "Pedagogical Hours",
  environment: "Environment",
  suggestedStudentCount: "No. of Suggested Students",
  autonomousWorkChronologicalHours: "Chronological Hours of Autonomous Work",
  assistantshipHoursCount: "No. of Assistantship Hours",
  prerequisites: "Prerequisites",

  // ========== Indications ==========
  noGuidelines: "No guidelines available.",
  otherProgrammingIndications: "Other programming indications",

  // ========== Section 2: Subject Description ==========
  subjectDescription: "Subject Description",
  noDescriptionForEntity: "No description for {entity}.",
  noEntityForSubject: "There are no {entity1} for {entity2}.",

  // ========== Competences and Learning Outcomes ==========
  learningResults: "Learning Outcomes",

  // ========== Section 3: Learning Route Synthesis ==========
  learningRouteSynthesis: "Learning Route Synthesis",
  learningExperience: "Learning Experience",
  learningEnvironment: "Learning Environment",
  evaluationType: "Evaluation Type",
  weighting: "Weighting",
  finalWeighting: "Final Weighting",
  exam: "Exam",
  total: "Total",
  teacherNote: "Note: The teacher may add partial evaluations or additional assessments to those indicated in this document. However, they must ensure that the evaluations maintain the weighting associated with each {entity}.",

  // ========== Section 4: Transversal Final Evaluation ==========
  transversalFinalEvaluation: "Transversal Final Evaluation",
  applicationCharacteristics: "Application Characteristics",
  avaReleaseWeek: "AVA Release Week",
  etDevelopmentTime: "Time for ET development or application",
  workType: "Type of work (individual or group)",
  evaluator: "Evaluator",
  etApplicationPlace: "ET application place",

  // ========== Section 5: Teachers ==========
  teachers: "Teacher(s)",
  teacherCount: "Number of Teachers",
  teacherProfile: "Teacher Profile {number}",
  theoryHours: "Theory hours",
  practicalHours: "Practical hours",
  nonInPersonHours: "Non in-person hours",
  specialization: "Specialization",
  workExperienceYears: "Years of work experience in the field",
  training: "Training",
  workExperienceValidity: "Work Experience Validity",
  observations: "Observations",

  // ========== Section 6: Assistant ==========
  assistant: "Assistant",
  assistantProfile: "Assistant Profile {number}",
  assistantRole: "Assistant Role",

  // ========== Section 7: Implementation Resources ==========
  implementationResources: "Implementation Resources",
  mandatoryBibliography: "Mandatory Bibliography",
  learningEnvironmentResourcesFer: "Resources by {entity} (FER Record reference)",
}
